<template functional>
    <li class="dml-main-category-tiles dml-main-category-tiles--two">
        <a class="dml-category-tile dml-category-tile--upper"
           :href="props.tiles.topTile.url"
           :rel="props.tiles.topTile.rel"
           data-ga="m_home.click_category_box"
           :data-ga-label="`${props.tiles.gender}_${props.tiles.topTile.name}`"
           data-t="22.2">
            <h3 class="dml-category-tile__title">{{props.tiles.topTile.name}}</h3>
            <picture>
                <source media="(min-width: 1280px)" :srcset="`${props.tiles.topTile.pictures.largex1}, ${props.tiles.topTile.pictures.largex2} 2x`">
                <img class="dml-category-tile__image lazy"
                     src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                     :data-srcset="`${props.tiles.topTile.pictures.smallx1}, ${props.tiles.topTile.pictures.smallx2} 2x`"
                     :alt="props.tiles.topTile.alt"
                     width="136"
                     height="136" />
            </picture>
        </a>
        <a class="dml-category-tile dml-category-tile--lower"
           :href="props.tiles.bottomTile.url"
           :rel="props.tiles.bottomTile.rel"
           data-ga="m_home.click_category_box"
           :data-ga-label="`${props.tiles.gender}_${props.tiles.bottomTile.name}`"
           data-t="22.2">
            <h3 class="dml-category-tile__title">{{props.tiles.bottomTile.name}}</h3>
            <picture>
                <source media="(min-width: 1280px)" :srcset="`${props.tiles.bottomTile.pictures.largex1}, ${props.tiles.bottomTile.pictures.largex2} 2x`">
                <img class="dml-category-tile__image lazy"
                     src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                     :data-srcset="`${props.tiles.bottomTile.pictures.smallx1}, ${props.tiles.bottomTile.pictures.smallx2} 2x`"
                     :alt="props.tiles.bottomTile.alt"
                     width="136"
                     height="136" />
            </picture>
        </a>
    </li>
</template>
<script>
    export default {
        name: 'dm-two-tiles',
        props: {
            tiles: {
                type: Object,
                required: true
            },
        }
    };
</script>
